// extracted by css-extract-rspack-plugin
export default {"Button":"QmZOq"};